import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NewComprobacion from '../views/NewComprobacion.vue'
import Proceso from '../views/Proceso.vue'
import ChangeDepto from '../views/Changedepto.vue'
import Deudores from '../views/deudores.vue'
import GrupoComprobacion from '../views/GrupoComprobacion.vue'
import EditarGrupoComprobacion from '../views/EditarGrupoComprobacion.vue'
import SolicitudComprobacion  from '../views/SolicitudComprobacion.vue'
import HistoricoComprobaciones from '../views/HistoricoComprobaciones.vue'
import HistoricoPolizas from '../views/HistoricoPolizas.vue'
import NotFound from '../views/NotFound.vue'
import store from '../store/index'
import bandeja_solicitudes_eliminadas from '../views/bandeja_solicitudes_eliminadas.vue'

import BandejaEntrada from '../views/BandejaEntrada.vue'

import login from '../views/login.vue'


Vue.use(VueRouter)

const isAuthenticated = (to,from,next) => {
    
    if(store.state.token != ''){
        let rutasValidasEmpleado = ['home','BandejaEntrada','NewComprobacion','NewestComprobacion','GrupoComprobacion','SolicitudComprobacion','EditarGrupoComprobacion','HistoricoComprobaciones','SolicitudesEliminadas'];
        let rutasValidasSupervisor = ['home','BandejaEntrada','NewComprobacion','NewestComprobacion','GrupoComprobacion','SolicitudComprobacion','BandejaEntrada','AutorizaGrupo','BandejaHistorica','AutorizaSolicitudes','reportes','EditarGrupoComprobacion','AutorizacionesTemporales','HistoricoComprobaciones','SolicitudesEliminadas','HistoricoPolizas'];
        let rutasValidasAdministrador = ['home','BandejaEntrada','NewComprobacion','NewestComprobacion','GrupoComprobacion','SolicitudComprobacion','BandejaEntrada','AutorizaGrupo','BandejaHistorica','AutorizaSolicitudes','ChangeDepto','Deudores','reportes','crearUsuario','EditarGrupoComprobacion','usuarios','AutorizacionesTemporales','DelegarCrearSolicitud','catalogoCentroCostos','catalogoCuentas','catalogoDepartamentos','catalogoGastos','catalogoDivisas','catalogoPuestos','SolicitudesEliminadas'];
        switch (store.state.user.nivel_acceso) {
            case 'empleado':
                if (rutasValidasEmpleado.includes(to.name)) {
                    next()
                    return
                }else{
                    next('/notfound');
                    return
                }
            case 'head manager':
                if (rutasValidasSupervisor.includes(to.name)) {
                    next()
                    return
                }else{
                    next('/notfound');
                    return
                }
            case 'supervisor':
                if (rutasValidasSupervisor.includes(to.name)) {
                    next()
                    return
                }else{
                    next('/notfound');
                    return
                }
            case 'financiero':
                if (rutasValidasSupervisor.includes(to.name)) {
                    next()
                    return
                }else{
                    next('/notfound');
                    return
                }
            case 'tesorero':
                if (rutasValidasSupervisor.includes(to.name)) {
                    next()
                    return
                }else{
                    next('/notfound');
                    return
                }
            case 'director financiero':
                    if (rutasValidasSupervisor.includes(to.name)) {
                        next()
                        return
                    }else{
                        next('/notfound');
                        return
                    }
            case 'director general':
                if (rutasValidasSupervisor.includes(to.name)) {
                    next()
                    return
                }else{
                    next('/notfound');
                    return
                }
            case 'administrador':
                if (rutasValidasAdministrador.includes(to.name)) {
                    next()
                    return
                }else{
                    next('/notfound');
                    return
                }
        }
    }
    next('/login');
}

const routes = [{
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Correos/ViewList',
        name: 'BandejaEntrada',
        component: BandejaEntrada,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/Nueva',
        name: 'NewComprobacion',
        component: () => import("../views/newestComprobacion.vue"),
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/New',
        name: 'NewestComprobacion',
        component: NewComprobacion,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/Grupo',
        name: 'GrupoComprobacion',
        component: GrupoComprobacion,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/Grupo/editar',
        name: 'EditarGrupoComprobacion',
        component: EditarGrupoComprobacion,
        beforeEnter: isAuthenticated
    },
    {
        path: '/comprobaciones/historial',
        name: 'HistoricoComprobaciones',
        component: HistoricoComprobaciones,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/polizas',
        name: 'HistoricoPolizas',
        component: HistoricoPolizas,
        beforeEnter: isAuthenticated
    },
    {
        path: '/comprobaciones/eliminadas',
        name: 'SolicitudesEliminadas',
        component: bandeja_solicitudes_eliminadas,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/Solicitudes',
        name: 'SolicitudComprobacion',
        component: SolicitudComprobacion,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/Proceso',
        name: 'Proceso',
        component: Proceso,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Departamentos/CambioDepto',
        name: 'ChangeDepto',
        component: ChangeDepto,
        beforeEnter: isAuthenticated
    },
    {
        path: '/Deudores/ViewList',
        name: 'Deudores',
        component: Deudores,
        beforeEnter: isAuthenticated
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/About.vue'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: NotFound
    },
    {
        path: '/user/create',
        name: 'crearUsuario',
        component: () => import('../views/user/create'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/usuarios',
        name: 'usuarios',
        component: () => import('../views/Usuarios'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/user/',
        name: 'users',
        component: () => import('../views/user/index'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/user/:id',
        name: 'user_view',
        component: () => import('../views/user/edit'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/role',
        name: 'roles',
        component: () => import('../views/roles/index'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/role/create',
        name: 'role_create',
        component: () => import('../views/roles/create')
    },
    {
        path: '/role/:id',
        name: 'role',
        component: () => import('../views/roles/edit'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/supervisor',
        name: 'supervisor',
        component: () => import('../views/supervisor/anticipo'),
        beforeEnter: isAuthenticated
    },{
        path: '/comprobacion',
        name: 'comprobacion',
        component : () => import('../views/supervisor/comprobacion'),
        beforeEnter: isAuthenticated
    },{
        path: '/add/anticipo',
        name: 'add_anticipo',
        component: () => import('../views/supervisor/add_anticipo'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/add/comprobante',
        name: 'add_comprobante',
        component: () => import('../views/user/add_comprobante'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/Reportes/Dashboard',
        name: 'reportes',
        component: () => import('../views/dashboard'),
        beforeEnter: isAuthenticated
    },
    /*{
        path: '/Comprobaciones/Bandeja',
        name: 'BandejaEntrada',
        component: () => import('../views/supervisor/bandeja_pendientes'),
        beforeEnter: isAuthenticated
    },*/
    {
        path: '/Comprobaciones/AutorizaGrupo',
        name: 'AutorizaGrupo',
        component: () => import('../views/supervisor/bandeja_solicitudes'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/BandejaHistorica',
        name: 'BandejaHistorica',
        component: () => import('../views/supervisor/bandeja_historica'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/Comprobaciones/AutorizaSolicitudes',
        name: 'AutorizaSolicitudes',
        component: () => import('../views/AutorizaSolicitud'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/Autorizaciones/Temporales',
        name: 'AutorizacionesTemporales',
        component: () => import('../views/AutorizacionesTemporales'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/Delegar/CrearSolicitud',
        name: 'DelegarCrearSolicitud',
        component: () => import('../views/DelegaGenerarSolicitud'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/catalogos/centrocostos',
        name: 'catalogoCentroCostos',
        component: () => import('../views/cruds/CentroCostos'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/catalogos/cuentas',
        name: 'catalogoCuentas',
        component: () => import('../views/cruds/Cuentas'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/catalogos/departamentos',
        name: 'catalogoDepartamentos',
        component: () => import('../views/cruds/Departamentos'),
        beforeEnter: isAuthenticated
    }, 
    {
        path: '/catalogos/gastos',
        name: 'catalogoGastos',
        component: () => import('../views/cruds/Gastos'),
        beforeEnter: isAuthenticated
    },
    {
        path: '/catalogos/divisas',
        name: 'catalogoDivisas',
        component: () => import('../views/cruds/Divisas'),
        beforeEnter: isAuthenticated
    },  
    {
        path: '/catalogos/puestos',
        name: 'catalogoPuestos',
        component: () => import('../views/cruds/Puestos'),
        beforeEnter: isAuthenticated
    },{
        path: '/comprobaciones/rechazados',
        name: 'rechazados',
        component: () => import("../views/supervisor/bandeja_cancelados.vue")
    },
    {
        path: '/comprobaciones/new',
        name: 'nuevo',
        component: () => import("../views/newestComprobacion.vue")
    }
]

const router = new VueRouter({
    routes
})

export default router